module.exports = __webpack_public_path__ + "static/media/02Demo Photo-ink-min.ec239edf.jpeg";